// extracted by mini-css-extract-plugin
export var cdsAssistiveText = "Title-module--cds--assistive-text--19985";
export var cdsVisuallyHidden = "Title-module--cds--visually-hidden--b013a";
export var hideFeedback = "Title-module--hide-feedback--023e6";
export var showFeedback = "Title-module--show-feedback--6bfbe";
export var skeleton = "Title-module--skeleton--de08e";
export var title = "Title-module--title--2bd58";